import { LayoutOptions } from '.';

const availableLayouts = (numberOfPlots: number) => {
  switch (numberOfPlots) {
    case 1:
      return ['fullSize'];
    case 2:
      return ['fullSize', '2x1', '1_1'];
    case 3:
      return ['fullSize', '2x1', '1_1', '1_2', '2_1'];
    case 4:
      return ['fullSize', '2x1', '1_1', '2x2'];
    default:
      return ['fullSize', '2x1', '1_1', '2x2', '2x3'];
  }
};

export const getDefaultLayout = (numberOfPlots: number, defaultLayout: LayoutOptions | undefined): LayoutOptions => {
  if (defaultLayout && availableLayouts(numberOfPlots).includes(defaultLayout)) {
    return defaultLayout;
  }

  switch (numberOfPlots) {
    case 1:
      return 'fullSize';
    case 2:
      return '2x1';
    case 3:
      return '1_2';
    case 4:
      return '2x2';
    default:
      return '2x3';
  }
};

/** Column span (out of 12) for every element in the given layout; mirrors what GridLayout renders. */
export const getGridSizes = (layout: LayoutOptions, count: number): number[] => {
  switch (layout) {
    case 'fullSize':
    case '2x1':
      return Array(count).fill(12);
    case '2_1':
      return [...Array(count > 0 ? count - 1 : 0).fill(6), ...Array(1).fill(12)];
    case '1_2':
      return [...Array(1).fill(12), ...Array(Math.max(count - 1, 0)).fill(6)];
    case '1_1':
      return count % 2 === 0 ? Array(count).fill(6) : [...Array(count - 1).fill(6), ...Array(1).fill(12)];
    case '2x2':
      return Array(count).fill(6);
    case '2x3':
      return Array(count).fill(4);
    default:
      return Array(count).fill(6);
  }
};

/** Layouts that stack everything in one row of full-height tiles. */
export const isFullHeightLayout = (layout: LayoutOptions) => layout === 'fullSize' || layout === '1_1';

export default getDefaultLayout;
